import React, { useEffect } from 'react';
import { ReduxState, useAppDispatch } from '../../../../../../../../store';
import { useSelector } from 'react-redux';
import { Column, Row } from '@ydistri/ds';
import { DisplayEntityIdType, EntityIdentificationType } from '@ydistri/api-sdk';
import { setImportIdentificationValue } from '../../../../../../../Calculations/calculationsSlice';
import RedistributionImportTextArea from './RedistributionImportTextArea';
import RedistributionImportEditorActions from './RedistributionImportEditorActions';
import { useApplicationConfiguration } from '../../../../../../../../hooks/useApplicationConfiguration';
import IdentificationTypeComponent from './IdentificationTypeComponent';
import RedistributionImportParsingResultOverview from './parsing_result_overview/RedistributionImportParsingResultOverview';
import InstructionSelectController from './InstructionSelectController';

const RedistributionImportEditor: React.FC = () => {
  const dispatch = useAppDispatch();

  const { displayProductId, displayStoreId } = useApplicationConfiguration();

  const identificationData = useSelector(
    (state: ReduxState) => state.calculations.redistributionImport.identificationData,
  );

  //set the default value for identification data based on displayProductId and displayStoreId
  //if the project uses codes, set the default value to Code and to CustomerId otherwise
  useEffect(() => {
    identificationData.forEach(identification => {
      //set the value only if it is not already set
      if (identification.value === undefined) {
        let value = EntityIdentificationType.CustomerId;

        if (identification.type === 'Product') {
          if (displayProductId === DisplayEntityIdType.Code) {
            value = EntityIdentificationType.Code;
          }
        } else {
          if (displayStoreId === DisplayEntityIdType.Code) {
            value = EntityIdentificationType.Code;
          }
        }

        dispatch(setImportIdentificationValue({ id: identification.id, value }));
      }
    });
  }, [dispatch, displayProductId, displayStoreId, identificationData]);

  return (
    <Row $gap="1rem" $flexWrap="nowrap" $flexGrow={1}>
      <Column $gap="1rem" $width="450px">
        <IdentificationTypeComponent type="Product" />
        <IdentificationTypeComponent type="Store" />
        <InstructionSelectController />
        <RedistributionImportTextArea label="Content" maxWidth="45rem" />
        <RedistributionImportEditorActions />
      </Column>
      <Column $flexGrow={1}>
        <RedistributionImportParsingResultOverview />
      </Column>
    </Row>
  );
};

export default RedistributionImportEditor;
